import React from "react";
import Card from "./Card";

interface StatCardProps {
  title: string;
  /** null = aún cargando / desconocido (no pases undefined) */
  value: number | null;
  icon?: React.ReactNode;
  className?: string;
}

export default function StatCard({
  title,
  value,
  icon,
  className = "",
}: StatCardProps): React.ReactElement {
  return (
    <Card className={`p-4 ${className}`}>
      <div className="mb-2 flex items-center gap-2">
        {icon ? <span className="icon-accent text-xl">{icon}</span> : null}
        <h3 className="text-base font-semibold">{title}</h3>
      </div>
      <div className="text-4xl font-bold leading-none">
        {value === null ? "—" : value}
      </div>
    </Card>
  );
}
